import { hasActiveFeatureGate, hasPermission } from '@sopranodesign/pulse-auth';

import McpProviders from './Pages/McpProviders';
import CreateMcpProvider from './Pages/CreateMcpProvider';
import EditMcpProvider from './Pages/EditMcpProvider';
import EditMcpSkill from './Pages/EditMcpSkill';

const routes = [
  {
    path: '/mcp/providers',
    component: McpProviders,
    name: 'MCP Providers',
    canAccess: [
      hasActiveFeatureGate('mcp'),
      hasPermission('view mcp skill providers')
    ],
    exact: true
  },
  {
    path: '/mcp/providers/create',
    component: CreateMcpProvider,
    name: 'New MCP Provider',
    canAccess: [
      hasActiveFeatureGate('mcp'),
      hasPermission('create mcp skill providers')
    ],
    exact: true
  },
  {
    path: '/mcp/providers/:id',
    component: EditMcpProvider,
    name: 'Edit MCP Provider',
    canAccess: [
      hasActiveFeatureGate('mcp'),
      hasPermission('view mcp skill providers')
    ],
    exact: true
  },
  {
    path: '/mcp/skills/:id',
    component: EditMcpSkill,
    name: 'Edit MCP Skill',
    canAccess: [
      hasActiveFeatureGate('mcp'),
      hasPermission('view mcp skills')
    ],
    exact: true
  }
];

export default routes;
